import { useAnnouncer } from "@/hooks/useAnnouncer";

/**
 * The app's single pair of ARIA live regions (G28). Mounted once in the shell
 * (App.tsx, beside Toaster). Both regions are ALWAYS mounted with text
 * injected later — a region added to the DOM at the same time as its text is
 * not reliably announced, so they must pre-exist and stay empty until used.
 *
 * `sr-only` keeps them off-screen in every theme and in print, so there is no
 * visual footprint to maintain.
 */
export function LiveAnnouncer() {
  const polite = useAnnouncer((s) => s.polite);
  const assertive = useAnnouncer((s) => s.assertive);
  return (
    <>
      <div className="sr-only" role="status" aria-live="polite" aria-atomic="true">
        {polite}
      </div>
      <div className="sr-only" role="alert" aria-live="assertive" aria-atomic="true">
        {assertive}
      </div>
    </>
  );
}
